export default "/_next/static/images/81fd8c3e86abad5df99afde2e4e9dee7.jpg";